import type { Notification } from '../types'

const NOTIFICATIONS_STORAGE_KEY = 'userNotifications'

/**
 * Сохранить уведомления в localStorage
 */
export const saveNotificationsToCache = (notifications: Notification[]): void => {
  localStorage.setItem(NOTIFICATIONS_STORAGE_KEY, JSON.stringify(notifications))
}

/**
 * Загрузить уведомления из localStorage
 * Возвращает null если кеш пуст или невалиден
 */
export const loadNotificationsFromCache = (): Notification[] | null => {
  const cachedData = localStorage.getItem(NOTIFICATIONS_STORAGE_KEY)
  if (!cachedData) return null

  try {
    const parsed = JSON.parse(cachedData)
    if (!Array.isArray(parsed)) {
      console.warn('[NotificationCache] Invalid cache shape. Clearing.')
      clearNotificationsCache()
      return null
    }
    return parsed
  } catch (error) {
    console.warn('[NotificationCache] Failed to parse cache. Clearing.', error)
    clearNotificationsCache()
    return null
  }
}

/**
 * Очистить кеш уведомлений
 */
export const clearNotificationsCache = (): void => {
  localStorage.removeItem(NOTIFICATIONS_STORAGE_KEY)
}
